module.exports = __webpack_public_path__ + "static/media/club-4.f2c10a4e.png";